import React, { useState, useEffect } from 'react';
import { Image_Url } from "../../ImageUrl/ImageUrl";
import './resetpassword.scss'
import { resetPasswordAction } from '../../actions/passwordAction';
import { useDispatch } from 'react-redux';
import { notify } from '../../services/notification';
import { useNavigate } from 'react-router-dom';
import { FaEye, FaEyeSlash, FaCheck, FaTimes } from 'react-icons/fa'
import { PASSWORD_CRITERIA, getPasswordErrors, isPasswordValid } from '../../utils/passwordValidator';

const ResetPasswordForm = () => {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState({
    password_error:"",
    confirmPassword_error:""
  });
  const [isLoad , setIsload] = useState(false);
  const [isnewPasswordVisible, setnewPasswordVisible] = useState(false);
  const [isconfirmPasswordVisible, setconfirmPasswordVisible] = useState(false);
  const [passwordTouched, setPasswordTouched] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const token = sessionStorage.getItem('resetToken');  

  useEffect(() => {
    if (!token) {
      navigate('/forgotpassword');
    }
  }, [token, navigate]);

  const passwordErrors = password ? getPasswordErrors(password) : PASSWORD_CRITERIA.map(c => c.key);
  const passwordValid = password ? isPasswordValid(password) : false;
  const showMismatchError = confirmPassword && password !== confirmPassword;

  const handlenewPasswordVisibility = () => {
    setnewPasswordVisible(!isnewPasswordVisible);
  };
  const handleconfirmPasswordVisibility = () => {
    setconfirmPasswordVisible(!isconfirmPasswordVisible);
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
    if (!passwordTouched) setPasswordTouched(true);
  };

  let validateForm = () => {
    let formIsValid = true;
    if (password === '') {
      formIsValid = false;
      setErrorMessage({ password_error: "Please enter Password" });
    } else if (!passwordValid) {
      formIsValid = false;
      setErrorMessage({ password_error: "Password does not meet required criteria." });
    } else if (confirmPassword === '') {
      formIsValid = false;
      setErrorMessage({ confirmPassword_error: "Please enter Confirm Password" });
    } else if (password !== confirmPassword) {
      formIsValid = false;
      setErrorMessage({ confirmPassword_error: "Passwords do not match!" });
    } else {
      setErrorMessage(" ");
    }
    return formIsValid;
  };

  const handleResetPassword = async () => {
    if (validateForm()) {
      setIsload(true);
      let apiReq = {
        new_password: password,
        verify_password: confirmPassword
      };
      let response = await dispatch(resetPasswordAction(apiReq, token));
      if (response == 200 || response != null) {
        sessionStorage.removeItem('resetToken');
        notify.success(response.data.message);
        setIsload(false);
        navigate('/passwordconfirmation', { state: { key: 'reset_password' } });
        window.scroll(0, 0);
      }else if(response === undefined){
        setIsload(false);
      }
    }
  };

  return (
    <div className='reset-flex'>
      <div className='tvs-logo'>
        <img src={Image_Url.TVSLOGO} alt='' />
      </div>
      <div className='reset-text'>Reset account password</div>
      <div className="reset-password-form">
        {isLoad ? (
          <div className='reset-skeleton-wrapper'>
            <div className='skeleton-shimmer skeleton-label'></div>
            <div className='skeleton-shimmer skeleton-input'></div>
            <div className='skeleton-shimmer skeleton-label'></div>
            <div className='skeleton-shimmer skeleton-input'></div>
            <div className='skeleton-shimmer skeleton-button'></div>
          </div>
        ) : (
          <>
            <div className='new_password'>
              <label>Password:</label>
              <div className='pswrd-input-label'>
              <input
              className='input-text-color'
                type={isnewPasswordVisible ? 'text' : 'password'}
                value={password}
                onChange={handlePasswordChange}
                maxLength={24}
              />
              <span
                  className={`pass-icon ${isnewPasswordVisible ? 'visible' : ''}`}
                  onClick={handlenewPasswordVisibility}
                >
                  {isnewPasswordVisible ? <FaEyeSlash /> : <FaEye />}
                </span>
            </div>
              {errorMessage && errorMessage.password_error && (
                <div className="error-message">{errorMessage.password_error}</div>
              )}
              {passwordTouched && !passwordValid && (
                <div className='password-criteria'>
                  <p className='criteria-header'>Your password must have:</p>
                  {PASSWORD_CRITERIA.map((criteria) => {
                    const isMet = !passwordErrors.includes(criteria.key);
                    return (
                      <div key={criteria.key} className={`criteria-item ${isMet ? 'met' : 'unmet'}`}>
                        {isMet ? <FaCheck className='criteria-icon met' /> : <FaTimes className='criteria-icon unmet' />}
                        <span>{criteria.label}</span>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>

            <div className='confirm_password'>
              <label>Confirm Password:</label>
              <div className='pswrd-input-label'>
              <input
              className='input-text-color'
                type={isconfirmPasswordVisible ? 'text' : 'password'}
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                maxLength={24}
              />
              <span
                  className={`pass-icon ${isconfirmPasswordVisible ? 'visible' : ''}`}
                  onClick={handleconfirmPasswordVisibility}
                >
                  {isconfirmPasswordVisible ? <FaEyeSlash /> : <FaEye />}
                </span>
            </div>
            {showMismatchError ? (
              <div className="error-message">Passwords do not match.</div>
            ) : (
              errorMessage && errorMessage.confirmPassword_error && (
                <div className="error-message">{errorMessage.confirmPassword_error}</div>
              )
            )}
            </div>
            <button onClick={handleResetPassword}>Reset Password</button>
          </>
        )}
      </div>
    </div>

  );
};

export default ResetPasswordForm;
